<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    <span v-if="isUpdate">
                        {{ $t("editar") }} {{ $t("saldograde") }}
                    </span>
                    <span v-else>
                        {{ $t("cadastrar") }} {{ $t("saldograde") }}
                    </span>
                    <b-icon
                        icon="information"
                        size="is-small"
                        v-tippy 
                        :title="$t('msg-tooltip-cadastro-grade')"
                    />
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="fecharModal()">
                    {{ $t("voltar") }}
                </button>
                <button
                    v-if="
                        (!integracao && !isUpdate && permissao.create) ||
                        (!integracao && isUpdate && permissao.update)
                    "
                    @click="save"
                    :disabled="isSaving || cantEdit"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <br />

        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-4">
                    <vss-select
                        :id="generateId(1)"
                        ref="empresaSelect"
                        title="empresas"
                        :options="empresas"
                        v-model="empresaSelected"
                        required
                        :invalid="empresaSelected == null"
                        :disabled="isUpdate || cantEdit || isSelected"
                        placeholder="selecione"
                        @input="loadGrade"
                    />
                </div>
                <div class="column is-4">
                    <vss-select
                        :id="generateId(2)"
                        ref="bloqkitSelect"
                        title="saldo-bloqkit"
                        :options="selectSimNao"
                        v-model="bloqkitSelected"
                        :disabled="cantEdit || !empresaSelected || !isSelected"
                        placeholder="selecione"
                        @input="edit('bloqvendaforakit')"
                        tooltipLabel="info-bloqvendaforakit"
                        tooltipSize="is-small"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-4">
                    <v-input
                        :id="generateId(3)"
                        ref="saldoInput"
                        v-model="estoque.saldo"
                        title="saldo"
                        placeholder="placeholder-preencha"
                        :invalid="isNull(estoque.saldo)"
                        required
                        v-mask="['#######']"
                        :disabled="cantEdit || !empresaSelected || !isSelected"
                        @input="edit('saldo')"
                        tooltipLabel="info-saldo"
                        tooltipSize="is-small"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-4">
                    <v-input
                        :id="generateId(4)"
                        ref="multiplicadorInput"
                        v-model="estoque.multiplicador"
                        title="multiplicadorweb"
                        placeholder="placeholder-preencha"
                        :invalid="isNull(estoque.multiplicador)"
                        v-mask="['#######']"
                        :disabled="cantEdit || !empresaSelected || !isSelected"
                        @input="edit('multiplicador')"
                        tooltipLabel="info-multiplicador"
                        tooltipSize="is-small"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-4">
                    <v-input
                        :id="generateId(5)"
                        ref="multiplicadortrocaInput"
                        v-model="estoque.multiplicadortroca"
                        title="mult-troca"
                        placeholder="placeholder-preencha"
                        :invalid="isNull(estoque.multiplicadortroca)"
                        v-mask="['#######']"
                        :disabled="cantEdit || !empresaSelected || !isSelected"
                        @input="edit('multiplicadortroca')"
                        tooltipLabel="info-multiplicadortroca"
                        tooltipSize="is-small"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-4">
                    <vss-select
                        :id="generateId(6)"
                        ref="bloqkitSelect"
                        title="situacao"
                        :options="selectSituacao"
                        v-model="situacaoSelected"
                        :disabled="cantEdit || !empresaSelected || !isSelected"
                        placeholder="selecione"
                        @input="edit('situacao')"
                    />
                </div>
                <div class="column is-full">
                    <v-textarea
                        :id="generateId(7)"
                        ref="observacaoInput"
                        v-model="estoque.observacao"
                        title="observacao"
                        :maxlength="255"
                        placeholder="placeholder-preencha"
                        :disabled="cantEdit || !empresaSelected || !isSelected"
                        :rows="3"
                        @input="edit('observacao')"
                        tooltipLabel="info-observacao"
                        tooltipSize="is-small"
                        :tooltipMultilined="true"
                        tooltipPosition="is-right"
                    />
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <label v-text="$t('grade')" />
                    <b-icon
                        icon="information"
                        size="is-small"
                        v-tippy 
                        :title="$t('msg-tooltip-grade')"
                    />
                    <empty-table-message
                        v-if="!tabelaLiberada&&!loadingTabela"
                        :msg="isEmpty ? 'sem-resultados' : 'grade-vazia'"
                    />
                    <loader v-if="loadingTabela" />
                    <b-table v-if="tabelaLiberada&&!loadingTabela" 
                        :data="data" 
                        :bordered="true">
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :width="f.width"
                            class="td-cell"
                            :sortable="f.sortable"
                        >
                            <template slot="header">

                                <div>
                                    <span>
                                        {{ f.key }}
                                    </span>
                                </div>

                            </template>

                            <template v-slot="props">

                                <div v-if="cantEdit || !props.row['y' + f.key]">
                                    <span>
                                        {{ props.row[f.key] }}
                                    </span>
                                </div>
                                <div v-else-if="props.row['selected' + f.key]" class="selecionado">
                                    <span>
                                        {{ props.row[f.key] }}
                                    </span>
                                </div>
                                <div v-else-if="(!props.row['selected' + f.key] && props.row['editado' + f.key])" class="editado">
                                    <a @click="loadSelectedData(props.row['linha'], props.row['y' + f.key], f.key)">
                                        <span>
                                            {{ props.row[f.key] }}
                                        </span>
                                    </a>
                                </div>
                                <div v-else class="naoSelecionado">
                                    <a @click="loadSelectedData(props.row['linha'], props.row['y' + f.key], f.key)">
                                        <span>
                                            {{ props.row[f.key] }}
                                        </span>
                                    </a>
                                </div>
                            
                            </template>  

                        </b-table-column>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ColaboradorService from "@/services/ColaboradorService";
import SaldoProdutoService from "@/services/vendas/produto/SaldoProdutoService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService.js";
import Message from "@/models/Message";
import SaldoProdutoValidation from "@/services/validations/vendas/produto/SaldoProdutoValidation";

export default {
    props: {
        idsaldoprodutograde: {
            type: Number,
            default: null,
        },
        integracao: {
            type: Boolean,
            default: true,
        },
        permissao: {
            type: Object,
            default: () => {},
        },
        idempresa: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            service: new SaldoProdutoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            validation: new SaldoProdutoValidation(this.msgs),

            isLoading: false,
            isSaving: false,
            msgs: [],

            idproduto: this.$route.params.id,
            estoque: {
                idsaldoprodutograde: null,
                idgrade:null,
                idgradelinha: null,
                idgradecoluna: null,
                idproduto: this.$route.params.id,
                idempresa: null,
                saldo: null,
                multiplicador: null,
                multiplicadortroca: null,
                bloqvendaforakit: null,
                observacao: null,
                situacao: null,
            },
            
            cantEdit: false,
            isUpdate: false,
            empresaSelected: null,
            empresas: [],
            debouncedOnSearchVendedor: null,
            selectSimNao: [{id:0, label: this.$t('nao')}, {id:1, label: this.$t('sim')}],
            selectSituacao: [{ id: 1, label: this.$t("ativo") },{ id: 0, label: this.$t("inativo") }],
            situacaoSelected: {},
            bloqkitSelected: {},
            tabelaLiberada: false,
            loadingTabela: false,
            fields: [],
            data: [],
            // @84566 - Dados referentes a construção da tabela (linhas e colunas)
            rawData: null,
            // @84566 - Dados referentes as celulas da tabela (valor, multiplicador, etc)
            fullData: null,
            isEmpty: false,
            // @84566 - Dados referentes a célula que foi selecionado
            dataSelecionada : {},
            isSelected: false,
            houveEdicao: false,
            itensEditados: [],
        };
    },
    created() {
        this.isUpdate = this.idsaldoprodutograde != null;
        this.debouncedOnSearchVendedor = this.debounce(this.onSearchVendedor, 500);

        if (this.isUpdate) {
            if (this.integracao) this.cantEdit = this.integracao;
            if (!this.permissao.update) this.cantEdit = !this.permissao.update;
            this.loadEmpresas()
            this.carregarDados();
        } else {
            this.loadEmpresas();
        }
    },
    methods: {
        // @84566 - Watched properties não funciona nesse caso, sendo necessário utilizar um método
        edit(input){
            this.houveEdicao = true;
            if(this.fullData){
                for(let data of this.fullData){
                    if(data.gradecoluna.idgradecoluna === this.estoque.idgradecoluna
                    && data.gradelinha.idgradelinha === this.estoque.idgradelinha){
                        // @84566 - Faz a atualização dos dados da célula
                        switch(input){
                            case 'bloqvendaforakit':
                                data.bloqvendaforakit = this.bloqkitSelected.id;
                                break;
                            case 'multiplicador':
                                data.multiplicador = this.estoque.bloqvendaforakit;
                                break;
                            case 'multiplicadortroca':
                                data.multiplicadortroca = this.estoque.multiplicadortroca;
                                break;
                            case 'situacao':
                                data.situacao = this.situacaoSelected.id;
                                break;
                            case 'observacao':
                                data.observacao = this.estoque.observacao;
                                break;
                            case 'saldo':
                                data.saldo = this.estoque.saldo
                        }
                    }
                }
            }
            // @84566 - Atualiza o valor exibido na tabela
            for(let i of this.data){
                if(i.linha === this.estoque.idgradelinha){
                    for(let f of this.fields){
                        if(f.id === this.estoque.idgradecoluna){
                            // @84566 - Verificação para não ficar um vazio na célula
                            i[f.key] = this.estoque.saldo ? this.estoque.saldo : 0; 
                        }
                    }
                }
            }

        },
        verificaEdicao(){
            if(this.houveEdicao){
                let flag = 0;
                if(this.itensEditados.length > 0){
                    // @84566 - Procura se já existe o registro na lista de itens editados
                    for(let f of this.itensEditados){
                        if(f.idgradelinha === this.estoque.idgradelinha 
                        && f.idgradecoluna == this.estoque.idgradecoluna){
                            f.saldo = this.estoque.saldo ? this.estoque.saldo : 0;
                            f.multiplicador = this.estoque.multiplicador ? this.estoque.multiplicador : 0;
                            f.multiplicadortroca = this.estoque.multiplicadortroca ? this.estoque.multiplicadortroca : 0;
                            f.observacao = this.estoque.observacao ? this.estoque.observacao : '';
                            f.bloqvendaforakit = this.bloqkitSelected ? this.bloqkitSelected.id : 0;
                            f.situacao = this.situacaoSelected ? this.situacaoSelected.id : 1;
                            flag = 1;
                            break;
                        }
                    }
                }
                // @84566 - Caso não exista, vai adicioná-lo a lista
                if (flag === 0){
                    this.itensEditados.push({
                        idsaldoprodutograde: this.estoque.idsaldoprodutograde ? this.estoque.idsaldoprodutograde : null,
                        idgrade: this.rawData.idgrade,
                        idgradelinha: this.estoque.idgradelinha,
                        idgradecoluna: this.estoque.idgradecoluna,
                        idproduto: this.$route.params.id,
                        idempresa: this.empresaSelected.id,
                        saldo: this.estoque.saldo ? this.estoque.saldo : 0,
                        multiplicador: this.estoque.multiplicador ? this.estoque.multiplicador : 0,
                        multiplicadortroca: this.estoque.multiplicadortroca ? this.estoque.multiplicadortroca : 0,
                        observacao: this.estoque.observacao ? this.estoque.observacao : '',
                        bloqvendaforakit: this.bloqkitSelected ? this.bloqkitSelected.id : 0,
                        situacao: this.situacaoSelected ? this.situacaoSelected.id : 1,
                    })
                }
            }
        },
        loadSelectedData(x, y, key){
            this.verificaEdicao();
            // @84566 - Zera o objeto
            this.estoque = Object.assign({
                idsaldoprodutograde: null,
                idgrade: this.rawData.idgrade,
                idgradelinha: null,
                idgradecoluna: null,
                idproduto: this.$route.params.id,
                idempresa: null,
                saldo: null,
                multiplicador: null,
                multiplicadortroca: null,
                bloqvendaforakit: null,
                observacao: null,
                situacao: null,
            })
            // @84566 - Seleciona o item e passa suas informações para os selects/inputs
            this.isSelected = true;
            this.estoque.idgradelinha = x;
            this.estoque.idgradecoluna = y;
            this.estoque.idproduto = this.$route.params.id;
            // @84566 - Verifica se existe os dados do saldo nos arquivos que vieram do banco
            if(this.fullData.length > 0){
                for(let f of this.fullData){
                    if(f.gradelinha.idgradelinha === x && f.gradecoluna.idgradecoluna === y){
                        this.estoque.idsaldoprodutograde = f.idsaldoprodutograde;
                        this.estoque.saldo = f.saldo;
                        this.estoque.multiplicador = f.multiplicador;
                        this.estoque.multiplicadortroca = f.multiplicadortroca;
                        this.estoque.observacao = f.observacao;
                        this.estoque.bloqvendaforakit = f.bloqvendaforakit;
                        this.estoque.situacao = f.situacao;
                        this.bloqkitSelected = this.selectSimNao.filter((e) => {
                            return e.id === f.bloqvendaforakit;
                        })[0]
                        this.situacaoSelected = this.selectSituacao.filter((e) => {
                            return e.id === f.situacao;
                        })[0]
                    }
                }
            } else if(this.itensEditados.length > 0){
                // @84566 - Verifica se existe registro anterior dos dados no array de itens para edição
                for(let f of this.itensEditados){
                    if(f.idgradelinha === x && f.idgradecoluna === y){
                        this.estoque.idsaldoprodutograde = f.idsaldoprodutograde;
                        this.estoque.saldo = f.saldo;
                        this.estoque.multiplicador = f.multiplicador;
                        this.estoque.multiplicadortroca = f.multiplicadortroca;
                        this.estoque.observacao = f.observacao;
                        this.estoque.bloqvendaforakit = f.bloqvendaforakit;
                        this.estoque.situacao = f.situacao;
                        this.bloqkitSelected = this.selectSimNao.filter((e) => {
                            return e.id === f.bloqvendaforakit;
                        })[0]
                        this.situacaoSelected = this.selectSituacao.filter((e) => {
                            return e.id === f.situacao;
                        })[0]
                    }
                }
            }
            // @84566 - Faz a seleção da próxima célula
            for(let e of this.data){
                if((e['linha'] === x)&&(e['y' + key] === y)){
                    e['selected' + key] = true;
                    // @84566 - LIMPA A LINHA
                    for(let i of this.fields){
                        if(i.id != y && e['selected' + i.key]){
                            if(this.houveEdicao){
                                e['editado' + i.key] = true
                                e['selected' + i.key] = false
                            } else {
                                e['selected' + i.key] = false
                            }
                        }
                    }
                // @84566 - LIMPA AS DEMAIS CÉLULAS
                } else {
                    for(let i of this.fields){
                        if(e['selected' + i.key]){
                            if(this.houveEdicao){
                                e['editado' + i.key] = true;
                                e['selected' + i.key] = false
                            } else {
                                e['selected' + i.key] = false
                            }
                        }
                    }
                }
            }
            this.houveEdicao = false;
        },
        criaTabela(grade, data){
            this.fields = [];
            // @84566 - Cria a coluna com os titulos
            this.fields.push({
                id: 0,
                key: `${grade.titulolinha}/${grade.titulocoluna}`,
                width: null,
                sortable: false,
                sortFn: false
            })
            // @84566 - Cria o cabeçalho dinamicamente
            for(let e of grade.assGradeGradeColunas){
                this.fields.push({
                    id: e.idgradecoluna,
                    key: e.descricao,
                    width: 800/(grade.assGradeGradeColunas.length),
                    sortable: false,
                    sortFn: false
                })
            }
            // @84566 - Cria as células internas da tabela
            for(let i = 0; i < grade.assGradeGradeLinhas.length; i++){
                let obj = {};
                for(let f = 0; f <= grade.assGradeGradeColunas.length; f++){
                    // @84566 - Caso seja a coluna com o titulo da linha
                    if(f === 0){
                        obj[this.fields[f].key] = grade.assGradeGradeLinhas[i].descricao
                    // @84566 - Caso seja dado das demais colunas
                    } else {
                        let item = {
                            saldo: 0,
                            y: this.fields[f].id,
                        };
                        for(let dado of data){
                            if(this.fields[f].id === dado.gradecoluna.idgradecoluna
                            && grade.assGradeGradeLinhas[i].idgradelinha === dado.gradelinha.idgradelinha){
                                item = {
                                    saldo: dado.saldo,
                                    y: dado.gradecoluna.idgradecoluna
                                }
                                break;
                            }
                        }
                        obj[this.fields[f].key] = item.saldo;
                        obj['selected' + this.fields[f].key] = false; 
                        obj['editado' + this.fields[f].key] = false; 
                        obj['y' + this.fields[f].key] = item.y;
                        obj['linha'] = grade.assGradeGradeLinhas[i].idgradelinha; 
                    }
                }
                // @84566 - Adiciona uma linha
                this.data.push(obj)
            }
        },
        loadGradeInfo(){
            if(this.empresaSelected){
                let idempresa = this.empresaSelected.id;
                this.service
                    .loadEstoqueGrade(
                        0,
                        1000,
                        4,
                        this.idproduto,
                        "",
                        idempresa
                    )
                    .then((body) => {
                        this.fullData = body.content;
                        // @84566 - Cria a tabela
                        this.criaTabela(this.rawData, body.content);
                    })
                    .finally((_) => {
                        if(this.isUpdate){
                            for(let e of this.fullData){
                                if(e.idsaldoprodutograde === this.idsaldoprodutograde){
                                    for(let f of this.fields){
                                        if(f.id === e.gradecoluna.idgradecoluna){
                                            this.loadSelectedData(e.gradelinha.idgradelinha, e.gradecoluna.idgradecoluna, f.key)
                                        }
                                    }
                                }
                            }
                        }
                        this.tabelaLiberada = true;
                        this.loadingTabela = false;
                        this.isLoading = false;
                    })
                }
        },
        loadGrade(){
            this.itensEditados = [];
            this.fields = [];
            this.data = [];
            this.dataSelecionada = {};
            this.estoque = {};
            this.isSelected = false;
            this.rawData = [];
            this.houveEdicao = false;
            if(this.empresaSelected){
                this.loadingTabela = true;
                this.service
                    .loadGrade(
                        this.idproduto
                    )
                    .then((body) => {
                        this.rawData = body.content;
                    })
                    .finally((_) => {
                        if(this.rawData){
                            this.loadGradeInfo();
                        } else {
                            this.msgs.push(new Message("alert", "msg-grade-inexistente", true));
                            this.isEmpty = true;
                            this.loadingTabela = false;
                        }
                    })
                }
        },
        save() {
            this.isSaving = true;
            this.isLoading = true;
            if(this.validation.validateGrade(this.estoque, this.$refs)){
                this.verificaEdicao();
                this.service
                    .saveGrade(this.itensEditados)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = this.$t(
                                this.estoque.idsaldoprodutograde != null
                                    ?'msg-edit-sucesso-n'
                                    :'msg-save-sucesso-n', 
                                { n: this.$t('aba-estoque') }
                            );
                            this.msgs.push(new Message("success", msg, true, false));
                            this.isLoading = false;
                            this.$emit("exibeMsg", msg)
                            this.$emit("fecharModal", true);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message("alert", value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message("error","msg-problema-realizar-acao",true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        console.error("Erro ao salvar: " + e);
                        this.msgs.push(
                            new Message("error", "msg-erro-salvar", true)
                        );
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.isSaving = false;
                    });
            } else {
                this.msgs.push(new Message("alert", "msg-campos-obrigatorios", true));
                this.isSaving = false;
                this.isLoading = false;
            }
        },
        carregarDados() {
            this.isLoading = true;
            this.empresaSelected = this.empresas.filter((e) => {
                return e.id === this.idempresa
            })[0]
            this.loadGrade()
        },
        loadEmpresas() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: e.id, label: e.rsocial });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: e.id, label: e.rsocial });
                });
            }
        },
        generateId(numberId) {
            return this.$route.name + "-estoque-" + numberId;
        },
        fecharModal() {
            if(this.itensEditados.length>0 || this.houveEdicao){
                this.$root.confirm({
                    message: this.$t("msg-tem-certeza-alteracoes"),
                    onConfirm: (_) => {
                        this.$emit("fecharModal", true);
                    },
                    onCancel: (_) => {
                    },
                });
            } else {
                this.$emit("fecharModal", true);
            }
        },
    },
};
</script>


<style lang="scss" scoped>
#main {
    padding: 30px 30px;

    .selecionado {
        background-color: $primary-color;
        font-weight: bold;
        color: $sovis-white;
        padding: auto;
        text-align: center;
    }

    .editado {
        background-color: $yellow;
        font-weight: bold;
        color: $sovis-black;
        text-align: center;
    }

    .naoSelecionado {
        text-align: center;
    }
}
</style>